module.exports = __webpack_public_path__ + "static/media/bungalowvip2.4a9d7a82.jpg";